import api from '../api';

interface ParamsBodyAcceptTerm {
    CdPerson: number;
    Accept: boolean;
    TypeContractModel: number;
    CdContractModel?: number | null;
}

interface ParamsPostAcceptTerm {
    token: string | null;
    body: ParamsBodyAcceptTerm;
}

const isBloquearVeiculoConectado = (payload: unknown): boolean => {
    if (payload === 'BloquearPagamentoVeiculoConectado') return true;
    if (payload && typeof payload === 'object') {
        const o = payload as Record<string, unknown>;
        const msg = o.message ?? o.Message ?? o.Data ?? o.data;
        if (msg === 'BloquearPagamentoVeiculoConectado') return true;
        if (typeof msg === 'string' && msg.includes('BloquearPagamentoVeiculoConectado')) return true;
    }
    return false;
};

const responseDataIsTrue = (data: unknown): boolean => {
    if (data === true) return true;
    if (data && typeof data === 'object') {
        const o = data as Record<string, unknown>;
        if (o.Data === true || o.data === true) return true;
    }
    return false;
};

export type PostAcceptTermResult =
    | { ok: true; data: unknown; status: number }
    | { ok: false; rejectLike: boolean; error_msg: string; status?: number };

export const PostAcceptTerm = async ({ token, body }: ParamsPostAcceptTerm): Promise<PostAcceptTermResult> => {
    try {
        const response = await api.post('/v1/Pagamento/AceiteTermo', body, {
            headers: {
                Authorization: token ? `Bearer ${token}` : undefined
            }
        });

        const { data, status } = response;

        if (status !== 200 || !responseDataIsTrue(data) || isBloquearVeiculoConectado(data)) {
            return {
                ok: false,
                rejectLike: true,
                error_msg: 'Não foi possível aceitar o termo',
                status
            };
        }

        return { ok: true, data, status };
    } catch (error: any) {
        const status = error?.response?.status;
        const respData = error?.response?.data;
        const error_msg =
            (typeof respData === 'string' && respData) ||
            respData?.message ||
            respData?.Message ||
            'Erro ao processar aceite do termo';

        const rejectLike = status !== 200 || isBloquearVeiculoConectado(respData);

        return {
            ok: false,
            rejectLike,
            error_msg,
            status
        };
    }
};
